import { Type, AlignLeft, CircleDot, CheckSquare, ChevronDownSquare, Hash, CalendarDays, Gauge, Paperclip } from "lucide-react";

export const QTYPES = [
  { key: "short_text", label: "Teks singkat", icon: Type },
  { key: "paragraph", label: "Paragraf", icon: AlignLeft },
  { key: "multiple_choice", label: "Pilihan ganda", icon: CircleDot },
  { key: "checkbox", label: "Kotak centang", icon: CheckSquare },
  { key: "dropdown", label: "Dropdown", icon: ChevronDownSquare },
  { key: "number", label: "Angka", icon: Hash },
  { key: "date", label: "Tanggal", icon: CalendarDays },
  { key: "scale", label: "Skala 1–5", icon: Gauge },
  { key: "file", label: "Upload file", icon: Paperclip },
];

export const CHOICE_TYPES = ["multiple_choice", "checkbox", "dropdown"];
export const qtypeMeta = (k) => QTYPES.find((q) => q.key === k) || QTYPES[0];
export const fillUrl = (id) => `${window.location.origin}/f/${id}`;
